module.exports = __webpack_public_path__ + "img/1501413952.7f32294b.jpg";